import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import jwt_decode from 'jwt-decode'

import { specialLoyaltyRefundAPI } from 'api/loyalty'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
import {
  SpecialLoyaltyRefundTxFormTypes,
  SpecialLoyaltyRefundTxFormSubmitValuesTypes,
  SpecialLoyaltyRefundTxFormSubmitActionsTypes,
} from 'types/specialLoyaltyRefundTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const INITIAL_VALUES: SpecialLoyaltyRefundTxFormTypes = {
  externalTransactionId: '',
  ident: '',
  loyaltyValue: 0,
  storeId: 0,
  deviceCode: '',
  cashier: '',
  guid: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const useSpecialLoyaltyRefundTx = (
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  initialValues: SpecialLoyaltyRefundTxFormTypes
  handleSubmitSpecialLoyaltyRefundTx: (
    values: SpecialLoyaltyRefundTxFormSubmitValuesTypes,
    actions: SpecialLoyaltyRefundTxFormSubmitActionsTypes
  ) => void
} => {
  const authToken = ls.get(LSKEY_TOKEN)
  const decodedToken: { username: string } = jwt_decode(String(authToken))
  const member = useMemberStore((state) => state.member)
  const [initialValues] = useState<SpecialLoyaltyRefundTxFormTypes>({
    ...INITIAL_VALUES,
    cashier: decodedToken?.username || '',
    ident: String(member?.cardNumber) || '',
  })

  const handleSubmitSpecialLoyaltyRefundTx = useCallback(
    async (
      values: SpecialLoyaltyRefundTxFormSubmitValuesTypes,
      actions: SpecialLoyaltyRefundTxFormSubmitActionsTypes
    ) => {
      try {
        await specialLoyaltyRefundAPI(values)
        toast.success('Special Loyalty refund successful.')
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`ERR: ${message.outcomeUserMessage}`)
      }
    },
    [onCloseModal]
  )

  return { member, initialValues, handleSubmitSpecialLoyaltyRefundTx }
}